'use client';

import { cn } from '@/lib/ui/cn';
import { useEqualHeight } from '@/hooks/useEqualHeight';
import { BlockNarrativeTileProps } from '@/types/blocks';

export function NarrativeTile(props: BlockNarrativeTileProps) {
  const { heading, text, className } = props;
  const headingRef = useEqualHeight<HTMLHeadingElement>('heading');

  return (
    <div
      data-equalize-root
      className={cn(
        'bg-sh-slate aspect-square w-full grow rounded-4xl px-7 py-12 lg:px-12 lg:py-17',
        className
      )}
      data-test='narrative-tile'
    >
      {heading && (
        <h3 ref={headingRef} className='sh-heading-3 mb-5 line-clamp-3'>
          {heading}
        </h3>
      )}
      {text && (
        <div
          className='sh-body prose prose-neutral'
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
}
